import dayjs from 'dayjs';
import { IMerchant } from 'app/shared/model/merchant.model';
import { IPublisher } from 'app/shared/model/publisher.model';

export interface IDeal {
  id?: string;
  name?: string | null;
  cashBackCurr?: string | null;
  cashBackAmt?: number | null;
  buzzCommission?: number | null;
  publisherCommission?: number | null;
  redeemPoint?: number | null;
  imagePath?: string | null;
  validityFrom?: dayjs.Dayjs | null;
  validityTo?: dayjs.Dayjs | null;
  type?: string | null;
  category?: string | null;
  instruction?: string | null;
  termsAndConditions?: string | null;
  inventoryTracking?: boolean | null;
  stockLevel?: number | null;
  createdAt?: dayjs.Dayjs | null;
  createdBy?: string | null;
  updatedAt?: dayjs.Dayjs | null;
  updatedBy?: string | null;
  merchant?: IMerchant | null;
  publisher?: IPublisher | null;
}

export const defaultValue: Readonly<IDeal> = {
  inventoryTracking: false,
};
